import { Component, ChangeDetectionStrategy } from "@angular/core";

/**
 * Decorative CSS flame animation, used as a background effect by the side navbar.
 */
@Component({
  selector: "app-gas-effect",
  templateUrl: "./gas-effect.component.html",
  styleUrls: ["./gas-effect.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class GasEffectComponent {}
